import gql from 'graphql-tag';

export const ALLOWED_CONTRACTS_COUNT = gql`
  query {
    contractsWhereActionIsAllowed(
      participantTypes: [ CUSTOMER ],
      action: CREATE,
      resource: APPOINTMENTS,
      serviceConfigFilters: {
        selfServiceEnabled: true
      }
    ) {
      totalCount
    }
  }
`;

